import useAppQuery from '../../../hooks/useAppQuery';
import API from '../../../services/API';
import useAppUser from '../../../hooks/useAppUser';
import { GetAirbnbFilterOptionsResponseTO } from './types/HostQuality.types';

const useHostQualityFilter = () => {
  const { isEmployee } = useAppUser();

  const { data: hostQualityFilter, isLoading: isHostQualityFilterLoading } =
    useAppQuery(
      ['hostQualityFilter'],
      async () => {
        const response = await API.get<GetAirbnbFilterOptionsResponseTO>(
          '/api/internal/airbnb/analytics/filter-options',
        );
        return response.data;
      },
      { enabled: isEmployee },
    );

  return {
    isLoading: isHostQualityFilterLoading,
    hostQualityFilter,
  };
};

export default useHostQualityFilter;
